import { render, staticRenderFns } from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=template&id=d27e5152&scoped=true&"
import script from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=script&lang=ts&"
export * from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=script&lang=ts&"
import style0 from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=style&index=0&id=d27e5152&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27e5152",
  null
  
)

export default component.exports